<template>
    <el-drawer
        title="活动数据"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="400px"
        @close="close"
    >
        <div class="drawer-content">
            <template v-if="detailData">
                <table class="info-table" style="width: 100%">
                    <tr>
                        <th>参与活动用户数</th>
                        <td width="60%">{{detailData.joinNum || 0}}</td>
                    </tr>
                    <tr>
                        <th>完成全部打卡用户数</th>
                        <td width="60%">{{detailData.clearCustomsNum || 0}}</td>
                    </tr>
                    <tr>
                        <th>活动分享人数</th>
                        <td width="60%">{{detailData.shareNum || 0}}</td>
                    </tr>
                    <tr>
                        <th>领取奖励人数</th>
                        <td width="60%">{{detailData.rewardNum || 0}}</td>
                    </tr>
                </table>
               
            </template>
        </div>
        <div class="drawer-footer">
            <el-button type="primary" @click="close">确 认</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
    data(){
        return{
            drawerShow: false,
            detailData: null,
            // dataLoading: false,
        }
    },
    methods:{
        show(data){
            this.detailData = data;
            this.drawerShow = true;
        },
        close(){
            this.detailData = null;
            this.drawerShow = false;
        }
    }
}
</script>

<style lang="scss" scoped>
td{
    font-size: 22px;
}
</style>